import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    cursor: 'pointer',
  },
  container: {
    '& input': {
      color: `${theme.palette.text.primary} !important`,
      fontWeight: '600',
    },
    '& textarea': {
      color: `${theme.palette.text.primary} !important`,
      fontWeight: '600',
    },
    '& fieldset': {
      borderColor: theme.palette.text.primary,
    },
    '& label': {
      color: `${theme.palette.text.primary} !important`,
    },
  },
  helperInfoText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& p': {
      margin: 0,
      fontSize: '0.75rem',
    },
  },
  infoText: {
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
